module.exports = __webpack_public_path__ + "style/img/SP_icon_Safe.99fa7b29.png";